<template>
    <div id="app">
        <router-view name="header"/>
        <div>
            <!-- <transition name="fade" appear> -->
                <router-view/>
            <!-- </transition> -->
        </div>
        <router-view name="footer"/>
    </div>
</template>
<script>
  export default {
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Refrigeration and HVAC controls',
      // all titles will be injected into this template
      titleTemplate: '%s | Electronic Technologies Corp',
      meta: [
        { charset: 'utf-8' },
        // { vmid: 'description', name: 'description', content: 'foo' }
      ]
    },
  }
</script>
<style>
.card-description, .description{
  font-weight: 400 !important;
}
p{
  font-weight: 400 !important;
}
@media screen and (min-width: 768px){
  .projects-5.controls-card .card-background.commercial .card-body   {
    padding-top: 250px !important;
    padding-bottom: 250px;
  }
}

/* .fade-enter-active, .fade-leave-active {
  transition: opacity .25s ease;
} */

/* .fade-leave-active {
  transition-delay: .25s;
} */

/* .fade-enter, .fade-leave-to {
  opacity: 0;
} */
</style>
